// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavTopBar-base__ibnYf{position:sticky;top:var(--size-0);right:var(--size-0);left:var(--size-0);z-index:var(--z-index-app-frame);display:flex;flex-direction:column;background-color:var(--surface-level-first)}.NavTopBar-mobileTabs__abfs9{will-change:transform}@media only screen and (min-width: 64rem){.NavTopBar-mobileTabs__abfs9{display:none}}.NavTopBar-mobileTabs__abfs9:not(:empty){display:flex;align-items:center;height:var(--size-13);padding:var(--size-0) var(--size-4);border-bottom:var(--size-0_25) solid var(--gray-a3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavTopBar-base__ibnYf",
	"mobileTabs": "NavTopBar-mobileTabs__abfs9"
};
export default ___CSS_LOADER_EXPORT___;
